import { defineSlotRecipe } from '@chakra-ui/react';
import { popoverAnatomy } from '@chakra-ui/react/anatomy';

export const popoverSlotRecipe = defineSlotRecipe({
  slots: popoverAnatomy.keys(),
  base: {
    header: {
      fontSize: 'lg',
      fontWeight: 'medium',
    },
    body: {
      overflow: 'auto',
    },
    closeTrigger: {
      minW: 'initial',
    },
  },
});
